import { environment } from "@environment";

export const clog = (...args: unknown[]) => {
  if (["dev", "sit", "uat"].includes(environment.appInfo.environment))
    console.log(...args);
};
